import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-79132384")
const _hoisted_1 = {
  key: 0,
  class: "item account"
}
const _hoisted_2 = { class: "login" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, " ", -1)
const _hoisted_4 = { class: "item" }
const _hoisted_5 = { class: "logout" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, " ", -1)
const _hoisted_7 = { class: "item" }
const _hoisted_8 = { class: "logout" }
const _hoisted_9 = { class: "item" }
const _hoisted_10 = { class: "logout" }
const _hoisted_11 = { class: "item" }
const _hoisted_12 = { class: "logout" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", null, " ", -1)
_popScopeId()

import { computed } from 'vue';
import useBalancerQuery from '@/composables/queries/useBalancerQuery';
import useFlakeCirculatesQuery from '@/composables/queries/useFlakeCirculatesQuery';
import useUserSettings from '@/composables/useUserSettings';
import { bnum } from '@/lib/utils';
import useNumbers, { FNumFormats } from '@/composables/useNumbers';
import useWeb3 from '@/services/web3/useWeb3';
import useTokens from '@/composables/useTokens';
import { getAddress } from '@ethersproject/address';
import usePools from '@/composables/pools/usePools';

/**
 * TYPES
 */
type Props = {
  account: boolean;
};

/**
 * PROPS
 */

export default _defineComponent({
  props: {
    account: { type: Boolean, required: true, default: false }
  } as unknown as undefined,
  setup(__props: {
  account: boolean;
}) {

const props = __props

const { fNum2 } = useNumbers();
const { currency } = useUserSettings();
const flakeCirculatesQuery = useFlakeCirculatesQuery();
const { prices } = useTokens();
const { appNetworkConfig } = useWeb3();
const { totalInvestedAmount } = usePools();
const useBalancer = useBalancerQuery();
/**
 * COMPUTED
 */
const balancer = computed(() => {
  return useBalancer.data.value ? useBalancer.data.value[0] : {};
});
const flakePrice = computed(() => {
  if (
    prices.value &&
    appNetworkConfig.addresses &&
    prices.value[getAddress(appNetworkConfig.addresses.flake || '')]
  ) {
    return (
      prices.value[getAddress(appNetworkConfig.addresses.flake || '')][
        currency.value
      ] || '0'
    );
  } else {
    return '0';
  }
});
const flakeCirculates = computed(() =>
  flakeCirculatesQuery.data.value
    ? flakeCirculatesQuery.data.value[0]
    : undefined
);
const flakeCirculation = computed(() => {
  return fNum2(
    bnum(flakeCirculates.value?.circulateBal || '0')
      .dividedBy(Math.pow(10, 18))
      .toFixed(0)
  );
});
const flakeCirculationCurrency = computed(() =>
  fNum2(
    bnum(flakeCirculates.value?.circulateBal || '0')
      .dividedBy(Math.pow(10, 18))
      .times(flakePrice.value)
      .toFixed(0),
    { style: 'currency', abbreviate: true }
  )
);
const lockedFlake = computed(() => {
  return fNum2(
    bnum(flakeCirculates.value?.lockedFlake || '0')
      .dividedBy(Math.pow(10, 18))
      .toFixed(2)
  );
});
const lockedFlakeCurrency = computed(() => {
  return fNum2(
    bnum(flakeCirculates.value?.lockedFlake || '0')
      .dividedBy(Math.pow(10, 18))
      .times(flakePrice.value)
      .toFixed(0),
    { style: 'currency', abbreviate: true }
  );
});
const ratio = computed(() => {
  return fNum2(
    bnum(flakeCirculates.value?.ratioOflocked || '0')
      .dividedBy(1000)
      .toString(),
    FNumFormats.percent
  );
});

return (_ctx: any,_cache: any) => {
  const _component_BalCard = _resolveComponent("BalCard")!

  return (_openBlock(), _createBlock(_component_BalCard, { noPad: "" }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["grid divide-y lg:divide-x divide-custom-black-300", 
        props.account
          ? 'grid-rows-5 lg:grid-rows-1 lg:grid-cols-5'
          : 'grid-rows-4 lg:grid-rows-1 lg:grid-cols-4'
      ])
      }, [
        (__props.account)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('My Hexagon Investments')), 1),
              _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(fNum2)(_unref(totalInvestedAmount) || '', {
              style: 'currency',
              dontAdjustLarge: true
            })), 1),
              _hoisted_3
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('TVL')), 1),
          _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(fNum2)(_unref(balancer).totalLiquidity || '', {
              style: 'currency',
              dontAdjustLarge: true,
              maximumFractionDigits: 2,
              abbreviate: true
            })), 1),
          _hoisted_6
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('FLAKE Circulation ')), 1),
          _createElementVNode("p", _hoisted_8, _toDisplayString(_unref(flakeCirculationCurrency)), 1),
          _createElementVNode("span", null, _toDisplayString(_unref(flakeCirculation)) + " FLAKE", 1)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('Locked FLAKE ')), 1),
          _createElementVNode("p", _hoisted_10, _toDisplayString(_unref(lockedFlakeCurrency)), 1),
          _createElementVNode("span", null, _toDisplayString(_unref(lockedFlake)) + " FLAKE", 1)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('Ratio of locked FLAKE')), 1),
          _createElementVNode("p", _hoisted_12, _toDisplayString(_unref(ratio)), 1),
          _hoisted_13
        ])
      ], 2)
    ]),
    _: 1
  }))
}
}

})